interface WorkflowMapping {
  prod: string
  staging: string
  dev: string
}

interface Workflow {
  id: string
  name: string
}

const meetingPrepWorkflowId: WorkflowMapping = { prod: '8ah6p15n4on22e1o', staging: '2962c4s3mddn0g3s', dev: '4od448r9or4v7nvg' }
const env = import.meta.env.REACT_APP_ENV! as 'prod' | 'staging' | 'dev'

export const WORKFLOWS: { [key: string]: Workflow } = {
  meetingPrep: { id: meetingPrepWorkflowId[env], name: 'Auto Meeting Prep' },
}
